// @<COPYRIGHT>@
// ==================================================
// Copyright 2023.
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

import DesCatalogImagesViewViewModel from 'viewmodel/DesCatalogImagesViewViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';
import { DesAccConstants } from '../constant/desAccConstants';

/**
 * Class DesCatalogImagesView
 */
export default class DesCatalogImagesView extends DesBaseCatalogAcc {
    /**
     * constructor
     */
    constructor() {
        super(DesCatalogImagesViewViewModel);
    }

    get filterStatus() {
        return this.getAttribute(DesAccConstants.FILTERSTATUS);
    }

    get autoSelectFirst() {
        return this.getAttribute(DesAccConstants.AUTO_SELECT_FIRST)|| 'false';
    }

    getProps() {
        return {
            provider: this.provider,
            catalogspaceid: this.catalogspaceId,
            limit: this.limit,
            display: this.display,
            filterStatus: this.filterStatus,
            autoSelectFirst: this.autoSelectFirst
        };
    }

    /**
     * Observ acc attributes.
     *
     * @readonly
     * @static
     * @memberof DesCatalogImagesView
     */
    static get observedAttributes() {
        return [
            DesAccConstants.ACC_SESSION_ID, DesAccConstants.PROVIDER, DesAccConstants.LIMIT,
            DesAccConstants.CATALOG_SPACE_ID, DesAccConstants.DISPLAY, DesAccConstants.LOCALE,
            DesAccConstants.FILTERSTATUS, DesAccConstants.AUTO_SELECT_FIRST
        ];
    }
}

if (!window.customElements.get('des-catalog-images-view')) {
    window.customElements.define('des-catalog-images-view', DesCatalogImagesView);
}
